import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { IHistogeneticsDetailReportResponse, IHistogeneticsDetailReports } from '@nkr/store/index';
import { HeaderWrapper, NavItemWrapper, NavWrapper } from './styles';
import { Badge, Nav, Table } from 'react-bootstrap';
import {
    GridApi, ColumnApi, GridReadyEvent,
    CsvExportParams, ProcessCellForExportParams
} from 'ag-grid-community';
import { FormControl, Button, Well, Row, Col } from 'react-bootstrap';
import { downloadFile } from '../../../../services/download-file';
import { HistogeneticsCategory } from '@nkr/enums/index';
import HistogeneticslReportGrid from './histogenetics-trans-detail-grid';
import { IHistogeneticsRequest } from '@nkr/models/index';

interface IProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getHistogeneticsReport: (startDate: string, endDate: string) => Promise<IHistogeneticsDetailReportResponse>,
    getHistogeneticsExport: (startDate: string, endDate: string, reportId: number) => Promise<any>
}

interface IState {
    startDate: string,
    endDate: string,
    centerId: number,
    activeTab: HistogeneticsCategory,
    report: IHistogeneticsDetailReports,
    filteredList: IHistogeneticsRequest[];
}

class HistogeneticslReportList extends React.Component<IProps, {}> {
    readonly state: IState = {
        startDate: '',
        endDate: '',
        centerId: 0,
        activeTab: 0,
        report: null,
        filteredList: []
    }

    gridApi: GridApi = null;
    gridColumnApi: ColumnApi = null;

    onGridReady = (event: GridReadyEvent) => {
        this.gridApi = event.api;
        this.gridColumnApi = event.columnApi;

        this.gridApi.sizeColumnsToFit();
    }

    componentDidMount = () => {
        //get dates
        let startDate = '';
        let endDate = '';

        if (startDate == '' || endDate == '') {
            startDate = moment().startOf('month').format('YYYY-MM-DD');
            endDate = moment().endOf('month').format('YYYY-MM-DD');
        } else {
            startDate = this.state.startDate;
            endDate = this.state.endDate;
        }

        this.getData(startDate, endDate);
    }

    getData = (startDate: string, endDate: string) => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getHistogeneticsReport(startDate, endDate)
                .then((response: IHistogeneticsDetailReportResponse) => {

                    this.setState({
                        startDate: startDate,
                        endDate: endDate,
                        report: response.data.results
                    }, () => {

                        this.handleTabChange(HistogeneticsCategory.DonorHighResTT);

                    });

                    this.props.hideLoading();
                }).catch((ex) => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                });
        });
    }

    dateRangeSearch = () => {
        this.getData(this.state.startDate, this.state.endDate);
    }

    onGridSizeChanged = () => {
        // get the current grids width
        let gridWidth = document.getElementById('grid-wrapper').offsetWidth;

        // keep track of which columns to hide/show
        let columnsToShow = [];
        let columnsToHide = [];

        // iterate over all columns (visible or not) and work out
        // now many columns can fit (based on their minWidth)
        let totalColsWidth = 0;
        let allColumns = this.gridColumnApi.getAllColumns();

        for (let i = 0; i < allColumns.length; i++) {
            let column = allColumns[i];
            totalColsWidth += column.getMinWidth();

            if (totalColsWidth > gridWidth) {
                columnsToHide.push(column.getColId);
            } else {
                columnsToShow.push(column.getColId);
            }
        }

        // show/hide columns based on current grid width
        this.gridColumnApi.setColumnsVisible(columnsToShow, true);
        this.gridColumnApi.setColumnsVisible(columnsToHide, false);

        // fill out any available space to ensure there are no gaps
        this.gridApi.sizeColumnsToFit();
    }

    handleDateChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        this.setState({
            [name]: value
        });
    }

    handleExportHistogenetics = (reportId: number) => {
        let sDate = this.state.startDate;
        let eDate = this.state.endDate;
        let filenName = '';

        this.props.showLoading("Exporting CSV file, one moment please...").then(() => {
            this.props.getHistogeneticsExport(sDate, eDate, reportId).then((response: any) => {

                switch (reportId) {
                    case 1:
                        filenName = 'donorhighresstt';
                        break;
                    case 2:
                        filenName = 'recipienthighresstt';
                        break;
                    case 3:
                        filenName = 'fvhighresstt';
                        break;
                    case 4:
                        filenName = 'cryoreceived';
                        break;
                    case 5:
                        filenName = 'crypshipped';
                        break;
                    case 6:
                        filenName = 'aboupload';
                        break;
                }

                downloadFile(response.data, `histogenetics-transactions-` + filenName + `.csv`, 'text/csv');

                this.props.hideLoading();
            });
        });
    }

    handleTabChange = (selectedTab: number) => {
        let categoryList = [];
        let reportList = _.cloneDeep(this.state.report);

        switch (selectedTab) {
            case HistogeneticsCategory.DonorHighResTT:
                categoryList = reportList.donorHighResTtResults;
                break;

            case HistogeneticsCategory.RecipientHighResTT:
                categoryList = reportList.recipientHighResTtResults;
                break;

            case HistogeneticsCategory.FVHighResTT:
                categoryList = reportList.fvHighResTtResults;
                break;

            case HistogeneticsCategory.CryoReceived:
                categoryList = reportList.cryoReceivedResults;
                break;

            case HistogeneticsCategory.CryoShipped:
                categoryList = reportList.cryoShippedResults;
                break;

            case HistogeneticsCategory.AboUploads:
                categoryList = reportList.aboUploadResults;
                break;
    
            default:
                break
        }

        this.setState({
            filteredList: categoryList,
            activeTab: selectedTab
        });
    }

    csvExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: 'histogenetics-transactions-detail.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.headerName == 'Rank')
                    return params.node.rowIndex + 1;
                else if (colDef.colId == 'xpDate')
                    return moment(params.value).format('MM/DD/YYYY');

                return params.value;
            }
        };

        this.gridApi.exportDataAsCsv(params);
    }

    render = () => {
        if (this.state.report == null)
            return null;

        const totalDonorHighResTT = this.state.report.donorHighResTtResults.length;
        const totalRecipientHighResTT = this.state.report.recipientHighResTtResults.length;
        const totalFvHighResTT = this.state.report.fvHighResTtResults.length;
        const totalCryoReceived = this.state.report.cryoReceivedResults.length;
        const totalCryoShipped = this.state.report.cryoShippedResults.length;
        const totalAboUploaded = this.state.report.aboUploadResults.length;
        const tabWidth = '230';

        return (
            <>
                <HeaderWrapper className='container-fluid'>
                    <div className='billing-header'>
                        Histogenetics Transactions Report
                    </div>

                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 30 }}>
                            <div style={{ display: 'flex' }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                    <div style={{ marginRight: 5 }}>Start Date:&nbsp;</div>
                                    <div>
                                        <FormControl
                                            type='date'
                                            name='startDate'
                                            value={this.state.startDate}
                                            onChange={this.handleDateChange}
                                        />
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                    <div style={{ marginRight: 5 }}>End Date:</div>
                                    <div>
                                        <FormControl
                                            type='date'
                                            name='endDate'
                                            value={this.state.endDate}
                                            onChange={this.handleDateChange}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <Button bsStyle={'primary'} onClick={this.dateRangeSearch}>Search</Button>
                                </div>
                            </div>
                        </div>

                        <div style={{ marginBottom: 10 }}>
                            <Well style={{ fontSize: 14, padding: 10 }}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}>
                                        <div style={{ paddingRight: 10 }}>Donor High Res TT:</div>
                                        <div style={{ paddingRight: 20 }}>{totalDonorHighResTT}</div>
                                        <div><Button bsStyle="success" bsSize="xsmall" onClick={() => this.handleExportHistogenetics(1)}>Export CSV</Button></div>
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}>
                                        <div style={{ paddingRight: 10 }}>Recipient High Res TT:</div>
                                        <div style={{ paddingRight: 20 }}>{totalRecipientHighResTT}</div>
                                        <div><Button bsStyle="success" bsSize="xsmall" onClick={() => this.handleExportHistogenetics(2)}>Export CSV</Button></div>
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}>
                                        <div style={{ paddingRight: 10 }}>FV High Res TT:</div>
                                        <div style={{ paddingRight: 20 }}>{totalFvHighResTT}</div>
                                        <div><Button bsStyle="success" bsSize="xsmall" onClick={() => this.handleExportHistogenetics(3)}>Export CSV</Button></div>
                                    </div>
                                 
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div style={{ paddingRight: 10 }}>ABO Upload:</div>
                                        <div style={{ paddingRight: 20 }}>{totalAboUploaded}</div>
                                        <div><Button bsStyle="success" bsSize="xsmall" onClick={() => this.handleExportHistogenetics(6)}>Export CSV</Button></div>
                                    </div>
                                </div>
                            </Well>
                        </div>
                    </div>
                </HeaderWrapper>

                <NavWrapper verticalAlign='center' minTabWidth='85' fontSize='12px'>
                    <div style={{ paddingLeft: 15, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Nav bsStyle='tabs' className='acc-tabs' onSelect={(e: any) => this.handleTabChange(e)}>
                            <NavItemWrapper eventKey={HistogeneticsCategory.DonorHighResTT} active={this.state.activeTab == HistogeneticsCategory.DonorHighResTT} tabWidth={tabWidth}>
                                Donor High Res TT <b>({totalDonorHighResTT})</b>
                            </NavItemWrapper>

                            <NavItemWrapper eventKey={HistogeneticsCategory.RecipientHighResTT} active={this.state.activeTab == HistogeneticsCategory.RecipientHighResTT} tabWidth={tabWidth}>
                                Recipient High Res TT <b>({totalRecipientHighResTT})</b>
                            </NavItemWrapper>

                            <NavItemWrapper eventKey={HistogeneticsCategory.FVHighResTT} active={this.state.activeTab == HistogeneticsCategory.FVHighResTT} tabWidth={tabWidth}>
                                FV High Res TT <b>({totalFvHighResTT})</b>
                            </NavItemWrapper>                          

                            <NavItemWrapper eventKey={HistogeneticsCategory.AboUploads} active={this.state.activeTab == HistogeneticsCategory.AboUploads} tabWidth={tabWidth}>
                                ABO Uploads <b>({totalAboUploaded})</b>
                            </NavItemWrapper>

                        </Nav>
                    </div>
                </NavWrapper>

                <HistogeneticslReportGrid
                    reportList={this.state.filteredList}
                    selectedTab={this.state.activeTab}
                />
            </>
        );
    }
}

export default HistogeneticslReportList;